<template>
  <div v-show="guideShow">苹果手机请前往App store下载使用</div>
</template>

<script>
// import {
//   latest
// } from '@/http/api'

export default {
  data() {
    return {
      userAgent: navigator.userAgent,
      guideShow: false,
    };
  },
  created() {
    (async () => {
      // if (this.isAndroid(this.userAgent) || this.isHuaWei(this.userAgent)) {
      const baseDownloadUrl =
        "https://static1.coolbrainscience.cn/apps/android";
      if (this.isAndroid(this.userAgent)) {
        // 判断地区是中国大陆、港澳台
        try {
          const { data } = await (
            await fetch("https://tools.panbrain.net/ip-check")
          ).json();
          console.log("region", data);
          const { country } = data;
          const isChineseRegion = ["CN", "HK", "MO", "TW"].includes(country);
          if (isChineseRegion) {
            window.location.href = `${baseDownloadUrl}/banyi_latest.apk`;
          } else {
            window.location.href = `${baseDownloadUrl}/banyi_latest_en.apk`;
          }
        } catch (e) {
          // 默认跳转到英文版
          window.location.href = `${baseDownloadUrl}/banyi_latest.apk`;
        }
        // window.open('https://static1.coolbrainscience.cn/apps/android/banyi_latest.apk')
      } else {
        // 非 Android 设备（桌面/iOS）：展示下载指引，不要用 document.write
        // （document.write 在页面加载完成后会清空整个文档）
        this.guideShow = true;
      }
    })();
  },
  methods: {
    // isIOS() {
    //   return !!this.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    // },
    isAndroid() {
      return (
        this.userAgent.indexOf("Android") > -1 ||
        this.userAgent.indexOf("Linux") > -1
      );
    },
    isHuaWei() {
      return !!(this.userAgent.indexOf("windows nt") > -1);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/pages/pack.vue